<template>
  <div class="w-full h-full flex flex-col view-with-header" :class="$getBgClass()" @keydown.esc="closeWindow">
    <div class="header-wrap" :class="{
    expanded: !isHeaderCollapsed,
    collapsed: isHeaderCollapsed,
  }
    ">
      <transition enter-active-class="transition-all delay-200 duration-300 ease-in"
        leave-active-class="transition-all duration-200 ease-out" enter-class="opacity-0" enter-to-class="opacity-100"
        leave-class="opacity-100" leave-to-class="opacity-0">
        <chat-header-expanded v-if="!isHeaderCollapsed" :intro-heading="channelConfig.welcomeTitle"
          :intro-body="channelConfig.welcomeTagline" :avatar-url="channelConfig.avatarUrl"
          :show-popout-button="appConfig.showPopoutButton" />
        <chat-header v-if="isHeaderCollapsed && !isHome" :title="backButtonMessage"
          :avatar-url="channelConfig.avatarUrl" :show-popout-button="appConfig.showPopoutButton"
          :available-agents="availableAgents" />
      </transition>
    </div>
    <banner />
    <transition enter-active-class="transition-all delay-300 duration-300 ease-in"
      leave-active-class="transition-all duration-200 ease-out" enter-class="opacity-0" enter-to-class="opacity-100"
      leave-class="opacity-100" leave-to-class="opacity-0">
      <router-view />
    </transition>
    <branding :disable-branding="disableBranding" v-if="!isFullPageView" />
  </div>
</template>
<script>
import Banner from '../Banner.vue';
import Branding from 'widget/components/Branding.vue';
import ChatHeader from '../ChatHeader.vue';
import ChatHeaderExpanded from '../ChatHeaderExpanded.vue';
import configMixin from '../../mixins/configMixin';
import darkModeMixin from 'widget/mixins/darkModeMixin';
import { mapGetters } from 'vuex';
import { IFrameHelper } from 'widget/helpers/utils';
import getConfig from 'widget/helpers/config';

export default {
  name: 'ViewWithHeader',
  components: {
    Banner,
    Branding,
    ChatHeader,
    ChatHeaderExpanded,
  },
  mixins: [configMixin, darkModeMixin],
  data() {
    return {
      showPopoutButton: false,
      disableBranding: getConfig().webChannel.disableBranding || false,
    };
  },
  computed: {
    ...mapGetters({
      availableAgents: 'agent/availableAgents',
      appConfig: 'appConfig/getAppConfig',
      conversationProperties: 'conversation/getConversationProperties',
      darkMode: 'appConfig/darkMode',
    }),
    isHome() {
      return this.$route.name === 'home';
    },
    isPreChatForm() {
      return this.$route.name === 'prechat-form';
    },
    isMessages() {
      return this.$route.name === 'messages';
    },
    isHeaderCollapsed() {
      if (!this.hasIntroText) {
        return true;
      }

      return !this.isHome;
    },
    hasIntroText() {
      return (
        this.channelConfig.welcomeTitle || this.channelConfig.welcomeTagline
      );
    },
    isFullPageView() {
      return getConfig().webChannel.isFullPageView;
    },
    truncatedContent() {
      let content = this.conversationProperties?.initial_message?.content ?? this.$t('CHAT_TITLE');

      if (content?.length > 75) {
        return content.substring(0, 75) + '...';
      } else {
        return content;
      }
    },
    backButtonMessage() {
      if (this.isFullPageView) {
        if (this.isPreChatForm) {
          return this.$t('CREATE_A_TICKET');
        }

        return `${this.truncatedContent} [#${this.conversationProperties?.friendly_id}]`;
      }

      return this.channelConfig.websiteName;
    }
  },
  methods: {
    closeWindow() {
      IFrameHelper.sendMessage({ event: 'closeWindow' });
    },
    $getBgClass() {
      if (this.isFullPageView) {
        return;
      }

      return this.darkMode === 'dark' ? 'in-app-view-dark' : 'in-app-view-light';
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/scss/variables';
@import '../../assets/scss/mixins';

.header-wrap {
  flex-shrink: 0;
  transition: max-height 300ms;
  z-index: 99;
  @include shadow-large;

  &.expanded {
    max-height: 16rem;
  }

  &.collapsed {
    max-height: 4.5rem;
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 667px) {
    border-radius: 0;
  }
}

.in-app-view-light {
  background: linear-gradient(142deg, #E4EBF1, #ffffff);
}

.in-app-view-dark {
  background: linear-gradient(225deg, #1B2836, #293f51);
}

.is-full-page-view {
  .view-with-header {
    align-items: center;
  }

  .header-wrap {
    width: 100%;
  }
}
</style>
